export const PX_OBJ_CLASS = "PG-AAS-Int-ArtworkAgilityProperty";
export const DASHBOARD_PX_OBJ_CLASS = "PG-AAS-Int-Dashboard";
export const DASHBOARD_MODULE_PX_OBJ_CLASS = "PG-AAS-Data-DashboardModule";
export const DASHBOARD_CONFIG_PX_OBJ_CLASS = "PG-AAS-Data-DashboardConfig";
export const DASHBOARD_TEMPLATE = "NA";


export function buildDashboardModule({
  moduleId = "",
  moduleName = "",
  moduleType = "",
  userId = "",
  config = {},
  Sequence
}) {
  return {
    Module_ID: moduleId,
    Module_Name: moduleName,
    Module_Type: moduleType,
    pxObjClass: DASHBOARD_MODULE_PX_OBJ_CLASS,
    Template: DASHBOARD_TEMPLATE,
    User_ID: userId,
    Config: {
      pxObjClass: DASHBOARD_CONFIG_PX_OBJ_CLASS,
      ...config,
    },
    Sequence
  };
}

/**
 * Helper to build the full dashboard payload
 */
export function buildDashboardPayload({
  module,
}) {
  return {
    pxObjClass: PX_OBJ_CLASS,
    Dashboard: {
      pxObjClass: DASHBOARD_PX_OBJ_CLASS,
      DashboardModuleList: [module],
    },
  };
}
